@if (environment.newAuthPages) {
<app-auth-shell mode="signin">
  @if (isAlreadySignedIn) {
    <div class="auth-form">
      <h1 class="auth-title">You're already signed in</h1>
      <p class="auth-subtitle">Continue to the app, or sign out first if you meant to use a different account.</p>

      <button data-cy="already-signedin-continue-button" type="button" class="auth-btn auth-btn-block"
        (click)="continueToApp()">Continue to app</button>
      <button data-cy="already-signedin-signout-button" type="button" class="auth-btn auth-btn-secondary auth-btn-block"
        (click)="signOut()">Sign out</button>
    </div>
  } @else {
  <form [formGroup]="form" (ngSubmit)="login()" class="auth-form">
    <h1 class="auth-title">Sign in</h1>
    <p class="auth-subtitle">Enter your credentials to access your account.</p>

    @if (!cookiesEnabled) {
      <app-warning-panel [error]='true'>Cookies are disabled in your browser. Please enable cookies to sign in.</app-warning-panel>
    }

    <div class="auth-field">
      <label for="signin-email">Email</label>
      <input data-cy="email-input" class="auth-input" id="signin-email" type="email" formControlName="email"
        autocomplete="username" required placeholder="you@company.com">
      @if (form.get('email')?.touched && form.get('email')?.invalid) {
        <div class="auth-field-error">A valid email address is required.</div>
      }
    </div>

    <div class="auth-field">
      <label for="signin-password">Password</label>
      <input data-cy="password-input" class="auth-input" id="signin-password" type="password"
        formControlName="password" autocomplete="current-password" required placeholder="••••••••">
      @if (form?.controls.password.invalid && (form.dirty || form?.controls.password.touched)) {
        @if (form?.controls.password.errors.required) {
          <div class="auth-field-error">Password is required.</div>
        }
      }
    </div>

    <div class="auth-row">
      <span></span>
      <a data-cy="forgot-button" [routerLink]="'/resetpass'">Forgot password?</a>
    </div>

    @if (busy) {
      <simple-progress message='Logging In'></simple-progress>
    } @else {
      <button data-cy="submit-button" type="submit" class="auth-btn auth-btn-block" [disabled]="!form.valid || !cookiesEnabled">Sign in</button>
    }

    @if (!!error) {
      <app-warning-panel [error]='true'>{{error}}</app-warning-panel>
    }
    @if (showConfirm) {
      <a (click)="confirm()">Confirm Sign Up</a>
    }
  </form>
  }
</app-auth-shell>
} @else {
<style>
  .main {
  margin-top: 10em;
}
</style>
<app-bganimation tagName="body" className="warehouse"></app-bganimation>
<div class="main wider layout-row layout-align-center layout-justify-center">
  <form [formGroup]="form" (ngSubmit)="login()">
    <mat-card >
      <mat-card-header>
        <mat-card-title>Sign In</mat-card-title>
        <mat-card-subtitle>Sign In to barxui using an existing sign up.</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (!cookiesEnabled) {
          <app-warning-panel [error]='true'>Cookies are disabled in your browser. Please enable cookies to sign in.</app-warning-panel>
        }
        <div class="layout-row-gap-1 layout-align-start">
        </div>
        <div class="layout-row-gap-1 layout-align-start">
          <div class="layout-col">
            <mat-form-field class="wide">
              <mat-label>Email Address</mat-label>
              <input data-cy="email-input" type="email" matInput formControlName="email" required placeholder="Email">
              @if (form.get('email').hasError('email')) {
                <mat-error>Required</mat-error>
              }
              @if (form.get('email').hasError('required')) {
                <mat-error>Required</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="wide">
              <mat-label>Password</mat-label>
              <input data-cy="password-input" type="password" matInput formControlName="password" placeholder="Password"
                required />
              @if (form?.controls.password.invalid && (form.dirty || form?.controls.password.touched)) {
                <div>
                  @if (form?.controls.password.errors.required) {
                    <mat-error> Password is required. </mat-error>
                  }
                </div>
              }
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <div class="layout-col-gap-05">
          <div>
            @if (busy) {
              <simple-progress message='Logging In'></simple-progress>
            } @else {
              <button data-cy="submit-button" type="submit" mat-raised-button color="primary"
              [disabled]="!form.valid || !cookiesEnabled">Sign In</button>
              <button data-cy="forgot-button" mat-stroked-button [routerLink]="'/resetpass'">Forgot Password</button>
              <!-- <button mat-stroked-button [routerLink]="'/signup'">Sign Up</button> -->
            }
          </div>
          <div>
            @if (!!error) {
              <app-warning-panel [error]='true'>{{error}}</app-warning-panel>
            }
            @if (showConfirm) {
              <a (click)="confirm()">Confirm Sign Up</a>
            }
          </div>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
}
